import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { useNavigate } from "react-router-dom";
import { CForm, CFormLabel, CFormInput, CButton, CFormCheck } from '@coreui/react';
import AsyncSelect from 'react-select/async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import Select from 'react-select';
import useLocalStorage from '../store/useLocalStorage';


const urlApi = '/accounts';
const urlApi_2 = '/agreements';
const urlRouter = '/accounts';
const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}`, 'accept': 'application/json' } };
const userData = JSON.parse(localStorage.getItem('user_data'));
const username = localStorage.getItem('user_name');

// const typeArr = [
//   { value: 'Фізична особа', label: 'Фізична особа' },
//   { value: 'Юридична особа', label: 'Юридична особа' },
//   { value: 'Дилер', label: 'Дилер' }
// ];

const typeArr = (() => {
  try {
    return JSON.parse(process.env.REACT_APP_ACCOUNTS_TYPE);
  } catch (e) {
    console.error('Помилка парсингу REACT_APP_ACCOUNTS_TYPE:', e);
    return [];
  }
})();


const AccountsFormComponents = ({ data, type, setShowModalCreateAccount, setNewAccountModal, setNewAgreementModal, setIsUpdateOrder, allowUpdateOrder }) => {
  // console.log('data', data);

  const [myData, setMyData] = useState((data != undefined) ? data : "");
  const navigate = useNavigate();
  const [name, setName] = useState((myData != "") ? myData.name : '');
  const [description, setDescription] = useState((myData != "") ? myData.description : '');
  const [phone, setPhone] = useState((myData != "") ? myData.phone : '');
  const [isExistPhone, setIsExistPhone] = useState(false); // чи вже є в базі номер телефону
  const [user, setUser] = useState('');
  const [agreements, setAgreements] = useState([]); // всі договори контрагента
  const [isAgreementKasa, setIsAgreementKasa] = useState(false); // чи в контрагента є договір "Каса"
  const [isAgreementBank, setIsAgreementBank] = useState(false); // чи в контрагента є договір "Банк"
  //блок для завантаження ключа tiny
  const watchedItem = useLocalStorage('tinyKey')
  const [tinyKey, setTinyKey] = useState(watchedItem || '')
  /////////////////////////////////

  // const [manager, setManager] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedType, setSelectedType] = useState(null
    // {
    //   label: (myData != "" && myData.type != undefined) ? typeArr.find(e => e.value === myData.type)?.label : typeArr[0].label,
    //   // label: (myData != "" && myData.type != undefined) ? myData.type : typeArr[0].label,
    //   value: (myData != "" && myData.type != undefined) ? myData.type : typeArr[0].value,
    // }
  );

  // const [ipn, setIpn] = useState((myData != "") ? myData.ipn : '');
  //тут змінив label на value
  const [typeAcc, setTypeAcc] = useState((myData != "" && type == undefined) ? myData.type :
    // typeArr[0].label
    typeArr[0]?.value
  );
  const [edrpou, setEdrpou] = useState((myData != "") ? myData.edrpou : '');
  const [isExistEdrpou, setIsExistEdrpou] = useState(false); // чи вже є в базі код ЄДРПОУ

  // const [parent, setParent] = useState((myData != "") ? myData.parent : '');
  // const [director, setDirector] = useState((myData != "") ? myData.director : '');
  // const [code1c, setCode1c] = useState((myData != "") ? myData.code1c : '');
  const [manager, setManager] = useState((myData != "") ? myData.manager : '');

  //адреса сайту
  const [site, setSite] = useState(myData?.site ? myData.site : '')
  //адреса email
  const [email, setEmail] = useState(myData?.email ? myData.email : '')
  //порядок сортування
  const [orderValue, setOrderValue] = useState(myData?.sort || myData?.sort === 0 ? myData.sort : '')

  //Для дилерів
  //широта
  const [latitude, setLatitude] = useState(myData?.latitude ? myData.latitude : '')
  //довгота
  const [longitude, setLongitude] = useState(myData?.longitude ? myData.longitude : '')
  //адреса
  const [address, setAddress] = useState(myData?.billing_address_street ? myData.billing_address_street : '')
  //назва міста
  const [cityName, setCityName] = useState(myData?.billing_address_city ? myData.billing_address_city : '')
  //назва магазина
  const [shopName, setShopName] = useState(myData?.shortName ? myData.shortName : '')
  //розклад роботи
  const [workingHours, setWorkingHours] = useState('')
  //чекбокс для інтернет магазина
  const [isOnlineStore, setIsOnlineStore] = useState(myData?.typeOfActivity === 'web_store' ? true : false)

  const editorRef = useRef(null);
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextPostSuccess = "Контрагента створено";
  const popupTextPutSuccess = "Контрагента оновлено";
  const popupTextCreateAgreementKasa = "Договір \"Каса\" створено";
  const popupTextCreateAgreementBank = "Договір \"Банк\" створено";
  const popupTextEDRPOUWarning = "Введений код ЄДРПОУ в базі вже існує";
  const popupTextPhoneWarning = "Введений номер телефону в базі вже існує";

  const getUserName = (user) => {
    let fn = (user.firstName != undefined) ? `${user.firstName} ` : '';
    let ln = (user.lastName != undefined) ? `${user.lastName} ` : '';
    let un = (user.username != undefined) ? ` (${user.username})` : '';
    return `${fn}${ln}${un}`;
  };

  if (myData != "" && myData.user != undefined && user == '') {
    setUser(`/api/users/${myData.user.id}`);
    setSelectedOption({
      label: getUserName(myData.user),
      value: myData.user.id,
    });
  };

  useEffect(() => {
    // if (myData != "" && myData.manager != undefined && manager == '') {
    if (myData != "" && myData.manager != undefined) {
      setManager(`/api/users/${myData.manager.id}`);
      setSelectedManager({
        label: getUserName(myData.manager),
        value: myData.manager.id,
      });
    } else if (userData && username) {
      let user = {
        firstName: userData.first_name,
        lastName: userData.last_name,
        username: username
      }
      setManager(`/api/users/${userData.id}`);
      setSelectedManager({
        label: getUserName(user),
        value: userData.id,
      });
    };
  }, [myData, userData]);

  //Заповнення selectedType
  useEffect(() => {
    if (!typeArr || typeArr.length === 0) return;

    if (myData !== "" && myData.type !== undefined) {
      const match = typeArr.find(e => e.value === myData.type);
      if (match) {
        setSelectedType(match);
        setTypeAcc(match.value);
      } else {
        setSelectedType(typeArr[0]);
        setTypeAcc(typeArr[0].value);
      }
    } else {
      setSelectedType(typeArr[0]);
      setTypeAcc(typeArr[0].value)
    }
  }, [typeArr, myData]);


  // Функція для запиту за данити контрагента
  const getAccountData = (id) => {
    AxiosInstance.get(`${urlApi}/${id}`, header).then((response) => {
      // console.log('get accounts/id response', response);
      if (response.status === 200) {
        setMyData(response.data);
      };
    }).catch((error) => {
      console.error("Помилка запиту за даними контрагента", error);
    });
  };

  // Для запобігання оновлення замовлення при створенні контрагента, коли контрагент створюється з сторінки замовлення
  useEffect(() => {
    if (setIsUpdateOrder != undefined) {
      setIsUpdateOrder(false);
    }
  }, []);

  // Функція для створення контрагента
  const createAccount = (data_response) => {
    // console.log('data_response', data_response);
    AxiosInstance.post(`${urlApi}`, data_response, header).then((response) => {
      if (response.status === 201) {
        // Popup про успішні зміни
        popup.toastifySuccess(popupTextPostSuccess);
        // Створити договір
        createAgreementKasa(data_response, response.data.id);

        if (type != undefined && type === "create") {
          setNewAccountModal(
            {
              name: response.data.name,
              id: response.data.id
            },
          );

          // Для запобігання оновлення замовлення при створенні контрагента, коли контрагент створюється з сторінки замовлення
          allowUpdateOrder();
        } else {
          setMyData(response.data);
          return navigate(`${urlRouter}/update/${response.data.id}`);
        };
      };
    });
  };

  // Функція для оновлення контрагента
  const updateAccount = (data_response) => {
    AxiosInstance.put(`${urlApi}/${myData.id}`, data_response, header).then((response) => {
      // console.log('put account response', response);
      if (response.status === 200) {
        // Popup про успішні зміни
        popup.toastifySuccess(popupTextPutSuccess);
        setMyData(response.data);
        // return navigate(urlRouter);
      }
    });
  };

  // Функція для створення договору "Каса"
  const createAgreementKasa = (myData, accountId) => {
    const data_response = {
      name: `${myData.name} (Каса)`,
      account: `/api/accounts/${accountId}`,
      typePayment: "kasa",
    };

    // console.log('createAgreementKasa data_response', data_response);
    AxiosInstance.post(`${urlApi_2}`, data_response, header).then((response) => {
      if (response.status === 201) {
        if (type != undefined && type === "create") {
          setNewAgreementModal({
            name: response.data.name,
            id: response.data.id,
            typePayment: response.data.typePayment
          });
          // Закрити модальне вікно створення контрагента
          setShowModalCreateAccount(false);
        } else if (myData !== "" && type != undefined && type === "accountPage") {
          // popup.toastifySuccess(popupTextPutSuccess);
          popup.toastifySuccess(popupTextCreateAgreementKasa);
          // Оновити дані контрагента
          getAccountData(accountId);
        }
      } else {
        console.log('Помилка запиту');
      };
    });
  };

  // Функція для створення договору "Банк"
  // const createAgreementBank = (myData, accountId) => {
  const createAgreementBank = () => {
    const data_response = {
      name: `${myData.name} (Банк)`,
      // account: `/api/accounts/${accountId}`,
      account: `/api/accounts/${myData.id}`,
      typePayment: "bank",
      // active: 'on',
    };

    // console.log('createAgreementKasa data_response', data_response);
    AxiosInstance.post(`${urlApi_2}`, data_response, header).then((response) => {
      if (response.status === 201) {
        if (type != undefined && type === "accountPage") {
          // popup.toastifySuccess(popupTextPutSuccess);
          popup.toastifySuccess(popupTextCreateAgreementBank);
          // Оновити дані контрагента
          // getAccountData();
          getAccountData(myData.id);
        }
      } else {
        console.log('Помилка запиту');
      };
    });
  };

  const handleSubmit = event => {
    event.preventDefault();

    let v = true;
    let vError = '';

    if (manager == '') {
      v = false;
      vError += "-> Менеджер\n";
    }

    if (!v) {
      alert("Ви не заповнили обовязкові поля:\n" + vError);
    }

    if (v && editorRef.current) {
      // console.log(editorRef.current.getContent());
      let data_response = {
        name: name,
        description: description,
        edrpou: edrpou,
        phone: phone,
        // ipn: ipn,
        type: typeAcc,

        // parent: parent,
        // director: director,
        // code1c: code1c,
        manager: manager,
        // user: user,
        active: 'on',
        site,
        email,
        // sort: Number(orderValue),

        //
        // latitude,
        // longitude,
        // billing_address_street: address,
        // billing_address_city: cityName,
        // shortName: shopName,
        // typeOfActivity: isOnlineStore ? 'web_store' : ''
      };
      if (typeAcc === 'dealer') {
        data_response.latitude = latitude;
        data_response.longitude = longitude;
        data_response.billing_address_street = address;
        data_response.billing_address_city = cityName;
        data_response.shortName = shopName;
        data_response.typeOfActivity = isOnlineStore ? 'web_store' : '';
        if (orderValue !== '') {
          data_response.sort = Number(orderValue);
        }
      }

      if (user != "") {
        data_response["user"] = user;
      }

      // Додаткова перевірка по коду ЄДРПОУ та номеру телефона
      Promise.all([
        checkEdrpou(),
        checkPhone()
      ]).then(([isEdrpouValid, isPhoneValid]) => {
        // console.log('isEdrpouValid', isEdrpouValid);
        // console.log('isPhoneValid', isPhoneValid);

        if (isEdrpouValid && isPhoneValid) {
          // console.log("Надіслати форму");
          // Коли на момент створення замовлення не було створено контрагента
          if (type != undefined && type === "create") {
            // console.log("type === create");
            createAccount(data_response);
          } else if (myData != "") {
            console.log("put");
            console.log('data_response', data_response)

            updateAccount(data_response);
          } else {
            console.log("post");
            console.log('data_response', data_response)
            createAccount(data_response);
          };
        } else {
          let text = "";
          if (!isEdrpouValid) {
            text += "Код ЄДРПОУ."
          };
          if (!isPhoneValid) {
            text += " Номер телефону."
          };
          console.log(`Для надсилання форми правильно заповніть поля: ${text}`);
        };
      });
    };
  };

  const loadOptions = async (inputValue) => {
    return await AxiosInstance.get(`/users?firstName=${inputValue}&lastName=${inputValue}&username=${inputValue}`, { headers: { 'accept': 'application/json' } }).then((response) => {
      return response.data.map((result) => ({
        label: getUserName(result),
        value: result.id,
      }));
    });
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setUser(`/api/users/${selectedOption.value}`);
  };

  // Для типу особи
  const handleChange_2 = (value) => {
    console.log('value', value)
    setSelectedType(value);
    setTypeAcc(value.value);
  };

  const handleChangeManagerr = (selectedOption) => {
    setSelectedManager(selectedOption);
    setManager(`/api/users/${selectedOption.value}`);
  };

  // Функція для запиту за договорами
  const getAgreements = (id) => {
    // account.id
    AxiosInstance.get(`${urlApi_2}?account.id=${id}`, header).then((response) => {
      // console.log('get agreements response', response);
      if (response.status === 200) {
        setAgreements(response.data);
      };
    }).catch((error) => {
      console.error("Помилка запиту для отримання договорів по контрагенту:", error);
    });
  };

  // Функція для перевірки чи в контрагента є договір "Каса"
  const checkAgreementKasa = () => {
    const isKasa = agreements.some(item => item.typePayment === "kasa");
    setIsAgreementKasa(isKasa);
  };

  // Функція для перевірки чи в контрагента є договір "Каса"
  const checkAgreementBank = () => {
    const isBank = agreements.some(item => item.typePayment === "bank");
    setIsAgreementBank(isBank);
  };

  // Зробити запит за договорами
  useEffect(() => {
    // console.log('myData', myData);
    if (myData != "" && type === "accountPage") {
      getAgreements(myData.id);
    }
  }, [myData]);

  useEffect(() => {
    if (watchedItem) {
      setTinyKey(watchedItem)
    }
  }, [watchedItem])

  // Перевірити чи є договори "Каса" і "Банк"
  useEffect(() => {
    // console.log('agreements', agreements);
    checkAgreementBank();
    checkAgreementKasa();
  }, [agreements]);

  // Функція для перевірки коду ЄДРПОУ
  const checkEdrpou = async () => {
    // console.log('myData.edrpou', myData.edrpou);
    // console.log("onBlur edrpou", edrpou);
    if ((myData?.edrpou && myData.edrpou === edrpou) || edrpou === "") {
      // console.log('myData?.edrpou && myData.edrpou === edrpou) || edrpou === ""');
      setIsExistEdrpou(false);
      return true; // для перевірки чи можна надсилати форму
    } else {
      try {
        const isExist = await checkEdrpouInApi();
        // console.log('isExist', isExist);
        // debugger
        setIsExistEdrpou(isExist);
        return !isExist; // для перевірки чи можна надсилати форму
      } catch (error) {
        console.error('Помилка перевірки на api коду ЄДРПОУ: ', error);
        setIsExistEdrpou(true);
        return false; // для перевірки чи можна надсилати форму
      };
    };
  };

  // Функція для перевірки чи вже є в базі код ЄДРПОУ
  const checkEdrpouInApi = async () => {
    try {
      const response = await AxiosInstance.get(`${urlApi}?edrpou=${edrpou}`);
      // console.log('get edrpou response', response);
      if (response.data['hydra:totalItems'] !== 0) {
        // console.log('hydra:totalItems', response.data['hydra:totalItems']);
        popup.toastifyWarning(popupTextEDRPOUWarning);
        return true; // код ЄДРПОУ в базі вже існує
      } else {
        // console.log('hydra:totalItems', response.data['hydra:totalItems']);
        return false; // код ЄДРПОУ в базі ще не введений
      };
    } catch (error) {
      console.log("Помилка перевірки на api коду ЄДРПОУ: ", error);
      return true; // код ЄДРПОУ в базі вже існує
    };
  };

  // Функція для перевірки номера телефону
  const checkPhone = async () => {
    // console.log('myData.phone', myData.phone);
    // console.log("onBlur phone", phone);
    if ((myData?.phone && myData.phone === phone) || phone === "") {
      // console.log('myData?.phone && myData.phone === phone) || phone === ""');
      setIsExistPhone(false);
      return true; // для перевірки чи можна надсилати форму
    } else {
      try {
        const isExist = await checkPhoneInApi();
        // console.log('isExist', isExist);
        // debugger
        setIsExistPhone(isExist);
        return !isExist; // для перевірки чи можна надсилати форму
      } catch (error) {
        console.error('Помилка перевірки на api номера телефону: ', error);
        setIsExistPhone(true);
        return false; // для перевірки чи можна надсилати форму
      };
    };
  };

  // Функція для перевірки чи вже є в базі номер телефону
  const checkPhoneInApi = async () => {
    try {
      const response = await AxiosInstance.get(`${urlApi}?phone=${phone}`);
      // console.log('get phone response', response);
      if (response.data['hydra:totalItems'] !== 0) {
        // console.log('hydra:totalItems', response.data['hydra:totalItems']);
        popup.toastifyWarning(popupTextPhoneWarning);
        return true; // номер телефону в базі вже існує
      } else {
        // console.log('hydra:totalItems', response.data['hydra:totalItems']);
        return false; // номер телефону в базі ще не введений
      }
    } catch (error) {
      console.log("Помилка перевірки на api номер телефону: ", error);
      return true; // номер телефону в базі вже існує
    };
  };

  function handleOnlineStore(e) {
    setIsOnlineStore(e.target.checked)
    const checked = e.target.checked;
    setIsOnlineStore(checked);

    if (checked) {
      setLatitude(null);
      setLongitude(null);
      setAddress('')
      setCityName('')
    }
    else {
      setLatitude('');
      setLongitude('');
    }
  }



  // console.log('selectedType', selectedType)
  // console.log('typeAcc', typeAcc)
  // console.log('myData', myData)
  // console.log('orderValue', orderValue)
  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      {/* Кнопки для створення договорів */}
      {
        (myData != "" && type === "accountPage") &&
        <div>
          {
            !isAgreementKasa &&
            <CButton
              className="mb-3 me-3" color="secondary"
              onClick={() => createAgreementKasa(myData, myData.id)} title={`Створити для контрагента "${myData.name}" договір "Каса"`}
            >
              Створити договір Каса
            </CButton>
          }
          {
            !isAgreementBank &&
            <CButton
              className="mb-3" color="secondary"
              onClick={() => createAgreementBank()} title={`Створити для контрагента "${myData.name}" договір "Банк"`}
            >
              Створити договір Банк
            </CButton>
          }
        </div>
      }

      <CForm onSubmit={handleSubmit} className="mb-3">
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Назва*</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" required />
        </div>
        <div className="mb-3" style={{ zIndex: "102", position: "relative" }}>
          <CFormLabel htmlFor="exampleFormControlInput6">Тип</CFormLabel>
          <Select options={typeArr} value={selectedType} onChange={(value) => { handleChange_2(value) }} />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput3">Код ЄДРПОУ</CFormLabel>
          <CFormInput
            type="text" id="exampleFormControlInput3"
            value={edrpou} onChange={(e) => setEdrpou(e.target.value)}
            onBlur={() => checkEdrpou()}
            autoComplete="off"
            style={{ borderColor: isExistEdrpou ? "red" : "" }}
          />
          {isExistEdrpou && <span style={{ color: "red" }}>{popupTextEDRPOUWarning}</span>}
        </div>
        <div className="mb-3" style={{ zIndex: "101", position: "relative" }}>
          <CFormLabel htmlFor="exampleFormControlInput1">Користувач (Клієнт)</CFormLabel>
          <AsyncSelect
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions
            value={selectedOption}
            onChange={handleChange}
            className="flex-grow-1"
            placeholder="Виберіть..."
          />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput2">Опис(для дилера-розклад роботи)</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={description} onChange={(e) => {
            setDescription(e.target.value)
          }} autoComplete="off"
            required={typeAcc === 'dealer'}
          />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput4">Телефон*</CFormLabel>
          <CFormInput
            type="text" id="exampleFormControlInput4"
            value={phone} onChange={(e) => setPhone(e.target.value)}
            onBlur={() => checkPhone()}
            style={{ borderColor: isExistPhone ? "red" : "" }}
            autoComplete="off" required
          />
          {isExistPhone && <span style={{ color: "red" }}>{popupTextPhoneWarning}</span>}
        </div>
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput5">ipn</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput5" value={ipn} onChange={(e) => setIpn(e.target.value)} autoComplete="off" />
          </div> */}
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput6">Тип</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput6" value={type} onChange={(e) => setType(e.target.value)} autoComplete="off" />
          </div> */}
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput7">parent</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput7" value={parent} onChange={(e) => setParent(e.target.value)} autoComplete="off" />
          </div> */}
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput8">director</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput4" value={director} onChange={(e) => setDirector(e.target.value)} autoComplete="off" />
          </div> */}
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput8">code1c</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput6" value={code1c} onChange={(e) => setCode1c(e.target.value)} autoComplete="off" />
          </div> */}
        {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput9">Менеджер</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput9" value={manager} onChange={(e) => setManager(e.target.value)} autoComplete="off" />
          </div> */}
        <div className="mb-3" style={{ zIndex: "100", position: "relative" }}>
          <CFormLabel htmlFor="exampleFormControlInput1">Менеджер*</CFormLabel>
          <AsyncSelect
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions
            value={selectedManager}
            onChange={handleChangeManagerr}
            className="flex-grow-1"
            placeholder="Виберіть..."
            required
          // menuPortalTarget={document.body} //  DOM-елемент, в який буде відображено меню випадаючого списку. Цей компонент відображається на окремій сторінці accounts/create(update/id), то там {document.body} відображає нормально. Ще використовується в /orders/update/19466 для створення контрагента і відкритий список відображається під двома модальними вікнами, тому закоментував
          />
        </div>
        {/* Поле для sort */}
        {/* <div className="mb-3">
          <CFormLabel>Порядок сортування</CFormLabel>
          <CFormInput
            type="text"
            placeholder="Порядок сортування"
            value={orderValue}
            onChange={(e) => {
              const value = e.target.value;
              // тількі цифри
              if (/^\d*$/.test(value)) {
                setOrderValue(value);
              }
            }}

            autoComplete="off"
          />
        </div> */}

        {/* поле для сайту */}
        <div className="mb-3">
          <CFormLabel>Адреса сайту(поле обов'язкове для інтернет магазинів)</CFormLabel>
          <CFormInput
            type="text"
            placeholder="Адреса сайту"
            value={site}
            onChange={(e) => setSite(e.target.value)}
            autoComplete="off"
            required={typeAcc === 'dealer' && isOnlineStore}
          />
        </div>
        {/* адреса email */}
        <div className="mb-3">
          <CFormLabel>Адреса електронної почти</CFormLabel>
          <CFormInput
            type="text"
            placeholder="Адреса електронної почти"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="off"
          />
        </div>

        {selectedType?.value === 'dealer' &&
          <>
            {/* Чек бокс для онлайн магазина */}
            <div className="mb-3">
              <CFormCheck
                type="checkbox"
                id="is-online-store"
                label="Це інтернет-магазин"
                checked={isOnlineStore}
                // onChange={(e) => setIsOnlineStore(e.target.checked)}
                onChange={(e) => handleOnlineStore(e)}
              />
            </div>


            {/* Поле для широти і довготи */}
            {!isOnlineStore && <div className="mb-3">
              <CFormLabel>Координати (Широта і Довгота-обов'язкові для магазинів(не інтернет-магазинів))</CFormLabel>
              <div style={{ display: 'flex', gap: '10px' }}>
                <CFormInput
                  type="text"
                  placeholder="Широта"
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                  autoComplete="off"
                  required={typeAcc === 'dealer' && !isOnlineStore}
                />
                <CFormInput
                  type="text"
                  placeholder="Довгота"
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                  autoComplete="off"
                  required={typeAcc === 'dealer' && !isOnlineStore}
                />
              </div>
            </div>}
            {/* Поле адреси */}
            {!isOnlineStore && <div className="mb-3">
              <CFormLabel>Адреса</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Адреса"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                autoComplete="off"
                required={typeAcc === 'dealer' && !isOnlineStore}
              />
            </div>}
            {/* Назва міста */}
            {!isOnlineStore && <div className="mb-3">
              <CFormLabel>Назва міста</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Назва міста"
                value={cityName}
                onChange={(e) => setCityName(e.target.value)}
                autoComplete="off"
                required={typeAcc === 'dealer' && !isOnlineStore}
              />
            </div>}
            {/* Назва мазазина */}
            <div className="mb-3">
              <CFormLabel>Назва магазина</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Назва магазина"
                value={shopName}
                onChange={(e) => setShopName(e.target.value)}
                autoComplete="off"
                required
              />
            </div>
            {/* Поле для sort */}
            <div className="mb-3">
              <CFormLabel>Порядок сортування</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Порядок сортування"
                value={orderValue}
                onChange={(e) => {
                  const value = e.target.value;
                  // тількі цифри
                  if (/^\d*$/.test(value)) {
                    setOrderValue(value);
                  }
                }}

                autoComplete="off"
              />
            </div>

            {/* Чек бокс для онлайн магазина */}
            {/* <div className="mb-3">
              <CFormCheck
                type="checkbox"
                id="is-online-store"
                label="Це інтернет-магазин"
                checked={isOnlineStore}
                onChange={(e) => handleOnlineStore(e)}
              />
            </div> */}

          </>
        }



        <div className="mb-3" style={{ zIndex: "1", position: "relative" }}>

          <Editor
            // apiKey={apiKey}
            apiKey={tinyKey}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={(myData != "") ? myData.content : ''}
            init={{
              height: 500,
              // menubar: false,
              menubar: 'edit view insert format tools',
              // plugins: [
              //   'advlist autolink lists link image charmap print preview anchor',
              //   'searchreplace visualblocks code fullscreen',
              //   'insertdatetime media table paste code help wordcount'
              // ],
              plugins: [
                'advlist', 'autolink',
                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'code'
              ],
              // toolbar: 'undo redo | formatselect | ' +
              //   'bold italic backcolor | alignleft aligncenter ' +
              //   'alignright alignjustify | bullist numlist outdent indent | ' +
              //   'removeformat | help',
              toolbar: 'undo redo | blocks fontname fontfamily fontsize | bold italic underline strikethrough superscript subscript | ' +
                'backcolor forecolor |' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | table help',
              font_size_formats: '10px 12px 14px 16px 18px 24px 36px 48px 72px',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
          />
        </div>

        {
          (myData != "" && type == "accountPage") ?
            <CButton type="submit" color="success" title="Оновити контрагента">Оновити</CButton>
            :
            <CButton type="submit" color="success" title="Створити контрагента">Створити</CButton>
        }
        {
          (setShowModalCreateAccount != undefined) ?
            <CButton className="ms-3" color="secondary" onClick={() => setShowModalCreateAccount(false)} title="Закрити вікно для створення контрагента">Закрити</CButton>
            :
            <Link to={urlRouter} className="ms-3"><CButton type="submit" color="secondary" title="Повернутися на сторінку з списком контрагентів">Повернутися до списку</CButton></Link>
        }
      </CForm >
    </>
  );
}

export default AccountsFormComponents;